import React from "react";
import { useCallback, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  FormControlLabel,
  Checkbox,
} from "..";
import { ConfirmAction, ConfirmProps } from "./Confirm.types";
import { useStyles } from "./Confirm.styles";
import useBreakpoints from "../hooks/useBreakpoints";

export default function Confirm(props: ConfirmProps): JSX.Element {
  const { open, title, onClose, message, actions, notShowAgainId } = props;

  const classes = useStyles();
  const { mdUp } = useBreakpoints();

  const [activeIndex, setActiveIndex] = useState<number>();

  const [notShowAgain, setNotShowAgain] = useState(false);

  const handleAction = useCallback(
    async (action: ConfirmAction, index: number) => {
      setActiveIndex(index);
      if (action.onClick) {
        await action.onClick();
      }
      if (notShowAgain) {
        localStorage.setItem(notShowAgainId!, String(notShowAgain));
      }
      setActiveIndex(undefined);
      onClose();
    },
    [notShowAgain, notShowAgainId, onClose]
  );

  const handleClose = useCallback(() => {
    setNotShowAgain(false);
    onClose();
  }, [onClose]);

  const working = activeIndex !== undefined;

  const showAgainCheck = notShowAgainId ? (
    <FormControlLabel
      control={<Checkbox color="primary" />}
      label="Do not show this message again"
      onChangeValue={setNotShowAgain}
      checked={notShowAgain}
    />
  ) : undefined;

  return (
    <Dialog
      className={classes.root}
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent className={classes.content}>
        <Typography variant="body2" color="grey" tone={700} component="pre">
          {message}
        </Typography>
        {!mdUp && showAgainCheck && showAgainCheck}
      </DialogContent>
      <DialogActions extra={mdUp && showAgainCheck}>
        {actions.map((action, index: number) => (
          <Button
            variant={action.primary ? "contained" : "text"}
            key={index}
            onClick={() => handleAction(action, index)}
            disabled={working}
            color={action.primary ? "primary" : undefined}
            loading={activeIndex === index}
          >
            {action.label}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
}
